import { useFinanceSimulationSelector } from "@redux/reducers/deal";
import { getIsLOAJourneySelected } from "@shared/v2/lib/getIsLOAJourneySelected";

export const useIsLOAJourneySelected = () => {
  const financeSimulation = useFinanceSimulationSelector();

  return getIsLOAJourneySelected(financeSimulation.journey);
};
